'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
module.exports = function of() {
  var length = arguments.length;
  var A = new Array(length);
  while (length--) A[length] = arguments[length];
  return new this(A);
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/collection-of.js
// module id = 521
// module chunks = 1